export default __webpack_public_path__ + "static/media/avatar_tommy_pyper2.6c0b90c1.mp3";